"use strict";

import Toolbox from "./toolbox";
import { ItemListingState, ItemListingConfig, itemListingConfigModifier } from "./listing-helper";
import ProductListPromotions from "./product-list-promotions";
import ListingFilterHandler from "./listing-filter-handler";
import ListingActionsHandler from "./listing-actions";

class ProductFetcherHandler {

	constructor(state, config, customHandlers) {

		this.state = state || ItemListingState;
		this.config = config || ItemListingConfig;
		this.handlers = {
			filterHandler: ListingFilterHandler,
			actions: ListingActionsHandler
		};


		if (typeof customHandlers === "object" && customHandlers) {
			for (const key of Object.keys(customHandlers)) {
				this.handlers[key] = customHandlers[key];
			}
		}

		if (!this.config.filterBar) {
			return false;
		}

		this.config.isSearchPage = false;
		this.config.searchTerm = this.config.filterBar.dataset.searchTerm || false;
		this.config.searchListing = this.config.filterBar.dataset.searchListing || "products";

		if (this.config.searchTerm) {
			this.config.isSearchPage = true;
		} else {
			this.config.searchTerm = false;
		}

		this.productListPromotions = new ProductListPromotions(state, config);
	}

	fetch(reset) {

		if (reset === undefined) {
			reset = false;
		}

		this.config.itemListingActions.classList.add("loading");
		this.config.mobileMenuActivityArea.classList.add("loading");

		const filtersObject = this.handlers.filterHandler.getCurrentFilter();

		//const itemsPerPage = filtersObject.productAmount ? Number(filtersObject.productAmount) : 20;

		if (this.state.currentIndex === 0) {
			this.state.currentIndex = Number(filtersObject.startIndex) + this.state.itemsPerPage;
		} else {
			this.state.currentIndex = this.state.currentIndex + this.state.itemsPerPage;
		}

		const productsList = document.querySelector(this.config.listingSelector);

		if (reset) {
			this.state.promoItemCounters.promoItemCounter = 0;
			this.state.promoItemCounters.itemCounter = 0;
			this.state.currentIndex = 0;
			this.state.lazyLoadCounter = 0;
			this.config.itemListingActions.classList.remove("done");
			while (productsList.firstChild) {
				productsList.removeChild(productsList.firstChild);
			}

		}

		filtersObject.startIndex = this.state.currentIndex;
		filtersObject.itemsPerPage = this.state.itemsPerPage;

		if (this.config.isSearchPage) {
			filtersObject.search = this.config.searchTerm;
			filtersObject.searchListing = this.config.searchListing;
		} else {
			filtersObject.settingsHash = this.state.viewOptionsWorkset.settingsHash;
			filtersObject.search = false;
		}

		const request = new XMLHttpRequest();

		if (this.config.ajaxMode === "GET") {
			request.open("GET", this.config.endpoint + "?fo=" + encodeURIComponent(btoa(JSON.stringify(filtersObject))), true);
		} else {
			request.open("POST", this.config.endpoint, true);
			request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
		}

		request.onload = () => {
			if (request.status >= 200 && request.status < 400) {
				const result = request.responseText;
				const feetched = JSON.parse(result);
				this.config.itemListingActions.classList.remove("loading");
				this.config.mobileMenuActivityArea.classList.remove("loading");

				if (feetched.done === true) {
					this.state.done = true;
					this.config.itemListingActions.classList.add("done");
				} else {
					this.config.itemListingActions.classList.remove("done");
				}

				const newproducts = document.createElement("div");
				newproducts.innerHTML = feetched.products;

				for (const productListItem of newproducts.querySelectorAll(".product-list-item")) {
					productListItem.classList.add("fade");
				}
				this.handlers.actions.updateListingCount(feetched.totalProductCount);

				let addedPromoItem = false;
				const randStart = Toolbox.randomBetween(this.state.promoItemCounters.promoItemStartPosition - 2, this.state.promoItemCounters.promoItemStartPosition + 1);

				while (newproducts.firstChild) {

					if (this.state.promoItemCounters.hasPromoItems === true) {
						// Also check Actions class addPromotionItemsToList method when changing these.

						if (this.state.promoItemCounters.promoItemCounter < this.state.promoItemCounters.showMaxPromoItems) {


							if (feetched.totalProductCount > this.state.promoItemCounters.promoItemShowAfterEvery && (randStart === this.state.promoItemCounters.itemCounter)) {
								addedPromoItem = true;
								this.productListPromotions.addPromotionItem(productsList);
								this.state.promoItemCounters.itemCounter = this.state.promoItemCounters.promoItemShowAfterEvery + this.state.promoItemCounters.promoItemRandomRange;
							} else {
								if (this.state.promoItemCounters.itemsBetweenPromosCounter >= this.state.promoItemCounters.minItemsBetweenPromos) {
									const randomPromoPosition = Toolbox.randomBetween(this.state.promoItemCounters.promoItemShowAfterEvery - this.state.promoItemCounters.promoItemRandomRange, this.state.promoItemCounters.promoItemShowAfterEvery + this.state.promoItemCounters.promoItemRandomRange);
									if (this.state.promoItemCounters.itemCounter % randomPromoPosition === 0 && this.state.promoItemCounters.itemCounter !== 0) {
										addedPromoItem = true;
										this.productListPromotions.addPromotionItem(productsList);
									}
								}
							}
							this.state.promoItemCounters.itemsBetweenPromosCounter++;
							this.state.promoItemCounters.itemCounter++;

							if ((this.state.promoItemCounters.itemsBetweenPromosCounter >= this.state.promoItemCounters.maxItemsBetweenPromos) && (this.state.promoItemCounters.promoItemCounter < this.state.promoItemCounters.showMaxPromoItems)) {
								addedPromoItem = true;
								this.productListPromotions.addPromotionItem(productsList);
							}
						}

					}

					productsList.appendChild(newproducts.firstChild);

				}

				if ((this.state.promoItemCounters.promoItemCounter < this.state.promoItemCounters.showMaxPromoItems)) {
					if (addedPromoItem === false && this.state.promoItemCounters.hasPromoItems === true && (feetched.totalProductCount > 0 && feetched.totalProductCount > this.state.promoItemCounters.promoItemShowAfterEvery)) {
						this.productListPromotions.addPromotionItem(productsList);
					} else if (this.state.promoItemCounters.hasPromoItems === true && (feetched.totalProductCount > 0 && feetched.totalProductCount <= this.state.promoItemCounters.promoItemShowAfterEvery)) {
						this.productListPromotions.addPromotionItem(productsList);
					}
				}

				this.state.nextPage++;
				this.handlers.actions.setNextPage(this.state.nextPage);
			} else {
				this.state.lazyLoadCounter = this.state.lazyLoadingTimes + 1;
				console.log("Couldn't load items.");
				productsList.innerHTML = this.config.noListingItems;
				this.config.itemListingActions.classList.remove("loading");
				this.config.itemListingActions.classList.add("done");
				this.config.mobileMenuActivityArea.classList.remove("loading");
			}
		};

		request.onerror = () => {
			this.state.lazyLoadCounter = this.state.lazyLoadingTimes + 1;
			console.log("Couldn't load items.");
			productsList.innerHTML = this.config.noListingItems;
			this.config.itemListingActions.classList.remove("loading");
			this.config.itemListingActions.classList.add("done");
			this.config.mobileMenuActivityArea.classList.remove("loading");
		};

		if (this.config.ajaxMode === "GET") {
			request.send();
		} else {
			request.send("filters=" + JSON.stringify(filtersObject));
		}
	}
}

export default ProductFetcherHandler;